import React from 'react';

const ErrorBoundaryFallback = (props: Props) => {
  const { error } = props;
  return <div>{error.message || error.toString()}</div>;
};

interface Props {
  error: Error;
  resetError(): void;
}

export default ErrorBoundaryFallback;
